<div class="nic-container">
  <app-product-intro-banner [eyebrow]="'nic.introBanner.eyebrow' | translate"
    [headline]="'nic.introBanner.headline' | translate" [description]="'nic.introBanner.description' | translate"
    [descriptionSecondParagraph]="'nic.introBanner.descriptionSecondParagraph' | translate"
    [primaryCtaLabel]="'nic.introBanner.primaryCtaLabel' | translate" [primaryCtaVariant]="'secondary'"
    [primaryCtaClass]="'nic-intro-cta-button'" [primaryCtaIconName]="'pop-window'" [primaryCtaIconPosition]="'trailing'"
    [mediaImageSrc]="introBannerAssets.mediaImageSrc" [mediaImageAlt]="'nic.introBanner.mediaImageAlt' | translate"
    [primaryCtaUrl]="nicWebsiteUrl"></app-product-intro-banner>

  <section class="nic-card-section" aria-labelledby="nic-options-title">
    <div class="container">
      <h2 id="nic-options-title">{{ 'nic.cardsSection.headline' | translate }}</h2>
      <p class="nic-card-section__description">{{ 'nic.cardsSection.description' | translate }}</p>

      <div class="nic-card-grid">
        <app-common-feature-card [variant]="'nic-option-1'" [config]="teacherOptionCardConfig"
          [ariaLabel]="'Option 1 card'"></app-common-feature-card>

        <app-common-feature-card [variant]="'nic-option-2'" [config]="noTeacherOptionCardConfig"
          [ariaLabel]="'Option 2 card'"></app-common-feature-card>
      </div>
    </div>
  </section>
</div>